import React, { useState, useEffect } from 'react';
import Recess from '../../../forms/recess';
import restApiClient from '../../../services/restApiClient';
import CrudTable from '../../../components/crudTable';
import FilterTree from '../../../helpers/filterTree';
import RecessDialog from '../../../components/recessDialog';
import { Container, CancelButton, AddBox } from './styles';

function RecessList({ match, history, ...props }) {
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState({ count: 0, values: [] });
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [orderBy, setOrderby] = useState({ date: 'asc' });
  const [searchBy, setSearchBy] = useState('');
  const [open, setOpen] = useState(false);

  const columns = Recess.tableSchema;

  useEffect(() => {
    restApiClient.recess
      .getAll(
        rowsPerPage,
        page * rowsPerPage,
        searchBy ? new FilterTree().like('date', searchBy).toString() : null,
        orderBy
      )
      .then((e) => {
        setRows(e.data);
      });
  }, [rowsPerPage, page, orderBy, searchBy]);

  return (
    <Container>
      <CrudTable
        title={`Recessos da radiologia`}
        customFooterComponent={
          <CancelButton
            onClick={() => history.goBack()}
            type="button"
            variant="contained"
            color="primary"
          >
            Voltar
          </CancelButton>
        }
        modelActions={Recess.actions}
        columns={columns}
        rows={rows}
        page={page}
        setPage={(page) => setPage(page)}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
        onOrderByChange={(orderBy) => setOrderby(orderBy)}
        orderBy={orderBy}
        setOrderBy={(value) => setOrderby(value)}
        searchBy={searchBy}
        setSearchBy={(value) => setSearchBy(value)}
        actions={{
          add: {
            icon: <AddBox />,
            onClick: (id) => setOpen(true),
            title: 'Cadastrar recesso',
            allowedActions: [Recess.actions.create],
          },
          delete: {
            onClick: (recessId, index) => {
              restApiClient.recess.delete(recessId).then(() => {
                const result = { ...rows };
                if (index > -1) {
                  result.values.splice(index, 1);
                  result.count--;
                }
                setRows(result);
              });
            },
            allowedActions: [Recess.actions.delete],
          },
        }}
        customCellRenderers={{
          date: {
            renderer: (field, value) => {
              return new Date(`${value}T03:24:00`).toLocaleDateString('pt-br');
            },
          },
        }}
      />

      <RecessDialog
        open={open}
        onCancel={() => {
          setOpen(false);
        }}
        onSuccess={(result) => {
          const recess = result.data;
          const newRows = [...rows.values];
          newRows[newRows.length] = recess;
          setRows({ ...rows, values: newRows });
          setOrderby({ date: 'asc' });
          setOpen(false);
        }}
        {...props}
      />
    </Container>
  );
}

export default RecessList;
